import { SectionHeader, Loader } from "@tfg/ui"

import { IngestionListWrapper } from "~/pages/Admin/Ingestion/ProductImport/IngestionListWrapper"
import { IngestionDocumentValidate } from "~/pages/Admin/Ingestion/ProductImport/components/IngestionDocumentValidate"
import { useProductImportContext } from "~/pages/Admin/Ingestion/ProductImport/provider/ProductImportContext"
import { ProductImportProvider } from "~/pages/Admin/Ingestion/ProductImport/provider/ProductImportProvider"
import { useAuth } from "~/store/auth-context"

export function ProductImport() {
  const { isLoadingOwners } = useProductImportContext()

  const { user } = useAuth()
  if (!user || !user.organization) {
    return null
  }
  return (
    <ProductImportProvider>
      <SectionHeader title="Product Import" />
      <IngestionDocumentValidate />
      {isLoadingOwners ? <Loader fullPage /> : <IngestionListWrapper />}
    </ProductImportProvider>
  )
}
